import React from "react";

export default function AWS_EC2() {
  return (
    <div>
      <h1>What is AWS EC2</h1>
      <p>
        Route: <code>/aws/ec2</code>
      </p>
      <p>Auto-generated component.</p>
    </div>
  );
}
